/**
 * 校验当前主机是否为本地或局域网开发环境
 */
export function isLocalHost(hostname?: string): boolean {
    const host = hostname ?? (typeof window !== "undefined" && window.location ? window.location.hostname : "localhost");
    return (
        host === "localhost" ||
        host === "127.0.0.1" ||
        host === "0.0.0.0" ||
        host === "::1" ||
        host.startsWith("192.168.") ||
        host.startsWith("10.") ||
        host.endsWith(".local") ||
        host === "local.lifemg.cn"
    );
}

/**
 * 获取 API 请求基础路径 (Base URL)
 * 1. 本地开发 (import.meta.env.DEV && isLocalHost()):
 *    返回 "" (相对路径)，走 Vite dev proxy 或 LightProxy，规避 localhost Cookie 写入受阻与 CORS 跨域问题；
 * 2. 部署环境 (QA/预发/生产等):
 *    返回环境变量 VITE_CONFIG_SERVER_PROXY_TARGET_LM (去除末尾多余斜杠)，直接与跨域的真实后端 API 建立通信；
 * 3. 兜底回退为 ""。
 */
export function getApiBaseUrl(): string {
    if (import.meta.env.DEV && isLocalHost()) {
        return "";
    }
    const envTarget = import.meta.env.VITE_CONFIG_SERVER_PROXY_TARGET_LM;
    if (envTarget && typeof envTarget === "string" && envTarget.trim()) {
        return envTarget.trim().replace(/\/+$/, "");
    }
    return "";
}

/**
 * 拼接完整的 API 资源地址（用于 el-upload 等原生组件）
 */
export function getApiUrl(path: string): string {
    const base = getApiBaseUrl();
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return base ? `${base}${cleanPath}` : cleanPath;
}

/**
 * 格式化登录二维码 URL，避免斜杠缺失导致拼接畸形
 */
export function getLoginQrCodeUrl(uuid: string): string {
    const target = (import.meta.env.VITE_CONFIG_SERVER_PROXY_TARGET_LM || "").trim().replace(/\/+$/, "");
    const base = target || "https://dev.lifemg.cn";
    return `pc_${base}/h5/mg-app-page-v3/scan-login?uuid=${uuid}`;
}
